import React from "react";
import { useNavigate } from 'react-router-dom';
import Layout from "../../components/Layout"
import thankyoImg from "../../../assets/images/Thanks-dc.gif";

const ThankYou = () => {
    const navigate = useNavigate();

    const handleClick = e => {
        e.preventDefault();

        localStorage.setItem('formCount', 7);
        navigate('/stepform');
    }

    return (
        <div className="form-page-wrapper">
            <Layout>
                <section className="thankyou-section">
                    <div className="container">
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="info-wrapper text-center">
                                <div className="image-wrapper">
                                    <img src={thankyoImg} />
                                </div>
                                <h2>We have recieved your application.</h2>
                                <p>Sit back and relax. we will connect with you soon</p>
                                <div className="button-wrapper">
                                    <a href="/" onClick={handleClick}>
                                        <button className="btn btn-primary">View Application</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>

    )
}

export default ThankYou;